import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/utility/layout/layout";
import Home from "../src/components/pages/home/home";
import About from "./components/pages/about";
import Services from "./components/pages/product";
import PageNotFound from "./components/pages/404Page";
import ContactSection from "./components/pages/home/contact";
// import PolicySection from "./components/pages/home/privacySection"
import PolicySection from "./components/pages/policy";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index exactly element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/product/:id"  element={<Services />} />
          <Route path="/contact"  element={<ContactSection />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/:id"  element={<PolicySection />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
